import { useParams } from '@jupiter/plugin-runtime/router';
import { Scope } from '@/typings/fe';

export const useScope = () => {
  const { scope = 'synthesize' } = useParams<{
    scope?: Scope;
  }>();

  return scope;
};
